import { noddiAsync, URLKeys } from 'noddi-async';
import { BrandType } from 'noddi-types';
import { commonTrackingEvents, tracking } from '../../tracking';

/**
 * Send the login SMS code. The endpoint is a GET with a side effect, so it runs as a
 * mutation: `send` resolves to whether the request for exactly this number succeeded,
 * never to a cached or since-changed query result.
 */
export const useSendVerificationSms = ({ brandName, isResend }: { brandName?: BrandType; isResend: boolean }) => {
  const { mutateAsync, isPending, error, variables } = noddiAsync.useDownload({
    type: URLKeys.getPhoneNumberVerification
  });

  const send = async (phoneNumber: string): Promise<boolean> => {
    tracking.track(commonTrackingEvents.loginSmsRequested, { isResend });
    try {
      await mutateAsync({ phoneNumber, domain: brandName });
      return true;
    } catch {
      // The caller renders `errorFor`.
      return false;
    }
  };

  /** The last send's refusal, only while `phoneNumber` is the number it was for. */
  const errorFor = (phoneNumber: string) => (variables?.phoneNumber === phoneNumber ? error : null);

  return { send, isSending: isPending, errorFor };
};
